import { IAppState } from '../../../AppModulesWrapper';

import { EFairPlayStatus } from '../../types/reducers/fairPlay';

export function selectFairPlayStatus(state: IAppState): EFairPlayStatus {
  const {
    fairPlay: { status },
  } = state.servicePickerWidget;

  return status;
}
